import { render, staticRenderFns } from "./RateScheduleCard.vue?vue&type=template&id=3264cbd8&"
import script from "./RateScheduleCard.vue?vue&type=script&lang=ts&"
export * from "./RateScheduleCard.vue?vue&type=script&lang=ts&"
import style0 from "./RateScheduleCard.vue?vue&type=style&index=0&id=3264cbd8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports